import { ListReducer, mergeEntities } from '../../store';
import { UserApi } from '../../api-typings/users';
import { transformUserBalances } from '../../user/user.reducer';

export const navigationUserBalancesReducer: ListReducer<
  'navigationUserBalances'
> = (state = {}, action) => {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (
        action.payload &&
        action.payload.ref.path[0] === 'navigationUserBalances'
      ) {
        const ref = action.payload.ref;
        const data = <UserApi>action.payload.data;
        return mergeEntities<'navigationUserBalances'>(
          state,
          transformUserBalances(data),
          ref,
        );
      }
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/navigation/reducers/userBalances.ts